import React, { useEffect, useState, useContext } from "react";
import CollabrativeImg from "../../../../Assets/Images/COLLABORATIVE.png";
import VisionaryImg from "../../../../Assets/Images/VISIONARY.png";
import StrategicImg from "../../../../Assets/Images/STRATEGIC.png";
import PerformanceImg from "../../../../Assets/Images/PERFORMANCE.png";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import GroupReportContext from "../../../../Context/GroupReportContext";
import { applyFullTieOrder, isFullTie, LEADERSHIP_CLOCKWISE } from "../../../../utils/quadrantTieOrder";

import Collabrative from "../../../../Assets/Images/Collabrative.png";
import Strategic from '../../../../Assets/Images/strat.png';
import Performance from '../../../../Assets/Images/perfor.png';
import Visionary from '../../../../Assets/Images/vis.png';


const LABEL_TO_ASSET = {
  COLLABORATIVE: CollabrativeImg,
  VISIONARY: VisionaryImg,
  STRATEGIC: StrategicImg,
  PERFORMANCE: PerformanceImg,
};

const styles = {
  checkboxStyles: `input[type='checkbox'] { width: 10px; height: 10px; opacity: 1; border-radius: 2px; border: 1px solid #000000; appearance: none; -webkit-appearance: none; display: inline-block; vertical-align: middle; margin: 0px 2px 1.5px 0px; transform: rotate(0deg); background-color: transparent; }`,
  page: { fontFamily: "Helvetica, sans-serif", color: "#333333", lineHeight: "1.6", backgroundColor: "#FFFFFF" },
  aboutSection: { padding: "16px 0 0px", margin: 0 },
  title: { fontFamily: "Helvetica, sans-serif", fontWeight: 700, fontStyle: "normal", fontSize: "14px", lineHeight: "18px", letterSpacing: "0px", textTransform: "uppercase", marginBottom: "13px", marginTop: 0, color: "#00577D" },
  iconRow: { display: "flex", justifyContent: "start", alignItems: "start", gap: "16px", paddingBottom: "16px" },
  iconImage: { width: "108px", height: "108px" },
  iconText: { fontFamily: "Helvetica, sans-serif", fontSize: "10px", lineHeight: "14px", color: "#000000", margin: 0, flex: 1, paddingBottom: "16px" },
  iconText2: { fontFamily: "Helvetica, sans-serif", fontSize: "10px", lineHeight: "14px", color: "#000000", margin: 0, flex: 1, },
  card: { marginBottom: "16px", backgroundColor: "#F1F8F1", padding: "12px", borderRadius: "5px", display: "flex", flexDirection: "column", gap: "8px" },
  cardChallenges: { padding: "12px", borderRadius: "5px", background: "#FFF0EC", display: "flex", flexDirection: "column", gap: "12px" },
  cardTitle: { fontFamily: "Helvetica, sans-serif", fontSize: "10px", lineHeight: "14px", fontWeight: 700, margin: 0, color: "#000000", letterSpacing: "0px", textTransform: "uppercase" },
  list: { fontFamily: "Helvetica, sans-serif", fontSize: "10px", lineHeight: "14px", fontWeight: 400, color: "#000000", margin: 0, listStyle: "none", padding: "0px" },
  labelStyle: { fontFamily: "Helvetica, sans-serif", fontWeight: 700, fontStyle: "normal", fontSize: "10px", lineHeight: "14px", letterSpacing: "0px", color: "#000000" },
};

const LeadershipCollabrative = ({ apiData, reportType, pageNumber }) => {
  const { averagePercentagesLeadership } = useContext(GroupReportContext);
  const [highestLeadershipStyle, setHighestLeadershipStyle] = useState("col");

  useEffect(() => {
    if (Array.isArray(averagePercentagesLeadership) && averagePercentagesLeadership.length > 0) {
      // All four tied: take the first style in clockwise order
      const top = isFullTie(averagePercentagesLeadership.map((el) => el?.avg))
        ? applyFullTieOrder(averagePercentagesLeadership, (el) => el?.name, (el) => el?.avg)[0]
        : averagePercentagesLeadership.reduce(
          (max, cur) => (Number(cur?.avg) > Number(max?.avg) ? cur : max),
          { name: "", avg: -Infinity }
        );
      const style = (top?.name || "col").toLowerCase();
      setHighestLeadershipStyle(style);
      return;
    }

    if (apiData?.memberResults?.allMembersData) {
      const labels_arr = ["performance", "strategic", "visionary", "collaborative"];
      const counts = { performance: 0, strategic: 0, visionary: 0, collaborative: 0 };

      Object.values(apiData.memberResults.allMembersData).forEach(memberAssessment => {
        if (!memberAssessment?.variables) return;
        const v = memberAssessment.variables.reduce((acc, el) => {
          acc[el.variable] = el.score;
          return acc;
        }, {});
        const mostValues = [
          v["per_round1_m"] || 0,
          v["strat_round1_m"] || 0,
          v["vis_round1_m"] || 0,
          v["col_round1_m"] || 0,
        ];
        const most_label = labels_arr[mostValues.indexOf(Math.max(...mostValues))];
        counts[most_label] = (counts[most_label] || 0) + 1;
      });

      const winner = isFullTie(Object.values(counts))
        ? LEADERSHIP_CLOCKWISE[0]
        : Object.entries(counts).reduce(
          (m, [k, c]) => (c > m.c ? { k, c } : m),
          { k: "collaborative", c: -Infinity }
        ).k;

      setHighestLeadershipStyle(winner.toLowerCase());
      return;
    }

    setHighestLeadershipStyle("col");
  }, [averagePercentagesLeadership, apiData]);

  const getLeadershipHeading = () => {
    if (highestLeadershipStyle.includes('col')) return 'COLLABORATIVE'
    if (highestLeadershipStyle.includes('strat')) return 'STRATEGIC'
    if (highestLeadershipStyle.includes('per')) return 'PERFORMANCE'
    if (highestLeadershipStyle.includes('vis')) return 'VISIONARY'
  }

  const getLeadershipImg = () => {
    if (highestLeadershipStyle.includes('col')) return Collabrative
    if (highestLeadershipStyle.includes('strat')) return Strategic
    if (highestLeadershipStyle.includes('per')) return Performance
    if (highestLeadershipStyle.includes('vis')) return Visionary
  }

  const getLeadershipInfo = () => {
    if (highestLeadershipStyle.includes('col')) return 'Collaborative Leadership is an extension of the Heart quadrant. These types of leaders excel in creating environments where everyone feels important and valued. They lead in ways that seek to foster a cooperative atmosphere and emphasize respect among team members, helping everyone perform their best.'
    if (highestLeadershipStyle.includes('strat')) return 'Strategic Leadership is an extension of the Mind quadrant. They play a crucial role in shaping an organization by developing robust structures, policies, and frameworks that lay the foundation for success.'
    if (highestLeadershipStyle.includes('per')) return 'Performance Leadership is an extension of the Strength quadrant. Performance Leaders are pivotal in driving organizational success through enhanced efficiency and problem-solving capabilities.'
    if (highestLeadershipStyle.includes('vis')) return 'Visionary Leadership is an extension of the Soul quadrant. These types of leaders are exceptional in their ability to bring leaders, teams, or the organization back to the deeper meaning and purpose behind all the daily activity.'
  }

  const getLeadershipInfo2 = () => {
    if (highestLeadershipStyle.includes('col')) return `Often referred to as "the People’s Leader,” these individuals focus first on relationships and may be naturally attuned to understand and constructively manage the feelings, wants, and needs happening beneath the surface.`
    if (highestLeadershipStyle.includes('strat')) return `These leaders excel at connecting big-picture goals with practical execution. Strategic Leaders are adept at defining clear roles and responsibilities within their teams, ensuring that every member knows their part in achieving organizational success.`
    if (highestLeadershipStyle.includes('per')) return `They can often translate high-level ideas into concrete actions.  Known for their expertise in management, they establish clear benchmarks and objectives that motivate team members to exceed expectations while balancing authority and resources to deliver top-notch customer service.`
    if (highestLeadershipStyle.includes('vis')) return `They often have a unique knack for seeing what others don't and articulating a future that motivates everyone to rally around a shared vision.`
  }

  const getLeadershipInfo3 = () => {
    if (highestLeadershipStyle.includes('col')) return `This can make them empathetic and considerate but they need to be careful not to get too caught up in people's issues to the point where it derails objectives and overrides healthy boundaries.`
    if (highestLeadershipStyle.includes('strat')) return `They are skilled at leveraging existing frameworks and processes to maximize results, always with an eye toward continual improvement and adaptation. However, their focus on control and structure can sometimes lead to challenges, such as overly autocratic decision-making or inflexible policies. `
    if (highestLeadershipStyle.includes('per')) return `However, their focus on goals and performance might lead them to view individuals more as means to an end rather than as whole persons, occasionally overlooking the personal contributions and individual needs of their team members. `
    if (highestLeadershipStyle.includes('vis')) return `They face challenges in translating broad visions into actionable steps, which can frustrate teams eager to implement these ideas.`
  }

  const getLeadershipInfo4 = () => {
    if (highestLeadershipStyle.includes('col')) return `At the heart of collaborative leadership is the belief that working together brings better results than working alone, "If you want to go fast, go alone. If you want to go far, go together."`
    if (highestLeadershipStyle.includes('strat')) return `These are the individuals who combine analytical prowess with operational efficiency, ensuring that the organization not only sets ambitious goals but also achieves them through meticulous strategy and execution. They are the masterminds behind the scenes, turning visions into reality with precision and foresight.`
    if (highestLeadershipStyle.includes('per')) return `Their knack for turning strategic visions into actionable steps ensures that the organization operates smoothly and achieves notable results.`
    if (highestLeadershipStyle.includes('vis')) return `Some Visionary leaders utilize symbols, ceremonies, and storytelling to enrich their leadership narrative, creating a resonant culture that transcends conventional business metrics and fosters a strong sense of community and shared purpose. These are the Sages, who embody wisdom and perspective, often motivated towards building and leaving a legacy.`
  }


  const renderItem = (title, desc) => (
    <li style={{paddingBottom:"4px" , display : "flex" , gap : "4px"}}>
      <input type='checkbox' disabled />
      <div>
        <span style={styles.labelStyle}> {title}: </span>
        {desc}
      </div>
      
    </li>
  );

  const pointOne = () => {
    if (highestLeadershipStyle.includes('col'))
      return renderItem("Empowering Team Members", "Creates space for people to lead with confidence.");
    if (highestLeadershipStyle.includes('strat'))
      return renderItem("Clear Direction", "Provides clarity on goals and how to achieve them.");
    if (highestLeadershipStyle.includes('per'))
      return renderItem("Goal Achievement", "Sets ambitious targets and consistently delivers results.");
    if (highestLeadershipStyle.includes('vis'))
      return renderItem("Innovative Thinking", "Introduces bold ideas that expand what’s possible.");
  }

  const pointTwo = () => {
    if (highestLeadershipStyle.includes('col'))
      return renderItem("Cross-Team Collaboration", "Connects departments and reduces silos.");
    if (highestLeadershipStyle.includes('strat'))
      return renderItem("Effective Planning", "Builds practical, actionable plans that simplify complex work.");
    if (highestLeadershipStyle.includes('per'))
      return renderItem("Strong Problem-Solving", "Identifies issues quickly and drives practical solutions.");
    if (highestLeadershipStyle.includes('vis'))
      return renderItem("Inspiring Alignment", "Connects daily work to a compelling mission.");
  }

  const pointThree = () => {
    if (highestLeadershipStyle.includes('col'))
      return renderItem("Stakeholder Relationships", "Builds trust with customers, partners, and teams.");
    if (highestLeadershipStyle.includes('strat'))
      return renderItem("Risk Management", "Anticipates and reduces risks before they become problems.");
    if (highestLeadershipStyle.includes('per'))
      return renderItem("Leading by Example", "Models discipline, commitment, and a high work ethic.");
    if (highestLeadershipStyle.includes('vis'))
      return renderItem("Brand Elevation", "Strengthens the brand through forward-thinking initiatives.");
  }

  const pointFour = () => {
    if (highestLeadershipStyle.includes('col'))
      return renderItem("Culture Building", "Shapes a positive, inclusive team culture.");
    if (highestLeadershipStyle.includes('strat'))
      return renderItem("Growing Skills + Learning", "Promotes continuous learning and skill development across the team.");
    if (highestLeadershipStyle.includes('per'))
      return renderItem("Performance Culture", "Sets clear expectations that motivate teams to excel.");
    if (highestLeadershipStyle.includes('vis'))
      return renderItem("Culture Shaping", "Promotes a culture of purpose and continual improvement.");
  }

  const pointFive = () => {
    if (highestLeadershipStyle.includes('col'))
      return renderItem("Boosting Morale", "Increases engagement by helping people feel valued.");
    if (highestLeadershipStyle.includes('strat'))
      return renderItem("Data-Driven Decisions", "Uses data and analysis to inform smarter strategic choices.");
    if (highestLeadershipStyle.includes('per'))
      return renderItem("Effective Resource Use", "Allocates time, tools, and people efficiently.");
    if (highestLeadershipStyle.includes('vis'))
      return renderItem("Developing Future Leaders", "Mentors and empowers the next generation.");
  }

  const challengesPointOne = () => {
    if (highestLeadershipStyle.includes('col'))
      return renderItem("Groupthink Risk", "Consensus can override better ideas.");
    if (highestLeadershipStyle.includes('strat'))
      return renderItem("Over-Control", "May micromanage and limit team creativity.");
    if (highestLeadershipStyle.includes('per'))
      return renderItem("Overemphasis on Results", "Outcome focus may impact morale and well-being.");
    if (highestLeadershipStyle.includes('vis'))
      return renderItem("Execution Gap", "Big ideas may lack clear, actionable steps.");
  }
  const challengesPointTwo = () => {
    if (highestLeadershipStyle.includes('col'))
      return renderItem("Slow Decisions", "Considering everyone’s feelings slows urgent decisions.");
    if (highestLeadershipStyle.includes('strat'))
      return renderItem("Feedback Resistance", "Can push back against feedback that challenges their strategy.");
    if (highestLeadershipStyle.includes('per'))
      return renderItem("Transactional Style", "Task orientation can feel impersonal to the team.");
    if (highestLeadershipStyle.includes('vis'))
      return renderItem("Sustaining Engagement", "Team enthusiasm can fade during slow or difficult phases.");
  }
  const challengesPointThree = () => {
    if (highestLeadershipStyle.includes('col'))
      return renderItem("Maintaining Objectivity", "Emotional investment can cloud judgment.");
    if (highestLeadershipStyle.includes('strat'))
      return renderItem("Neglecting People + Culture", "May focus too heavily on goals at the expense of morale.");
    if (highestLeadershipStyle.includes('per'))
      return renderItem("Short-Term Focus", "May prioritize quick wins over long-term goals.");
    if (highestLeadershipStyle.includes('vis'))
      return renderItem("Resistance to Change", "Conceptual ideas may face doubt or hesitation.");
  }
  const challengesPointFour = () => {
    if (highestLeadershipStyle.includes('col'))
      return renderItem("Avoiding Tough Conversations", "May delay confronting underperformance.");
    if (highestLeadershipStyle.includes('strat'))
      return renderItem("Scaling Difficulty", "Strategies that work small may not translate organization-wide.");
    if (highestLeadershipStyle.includes('per'))
      return renderItem("Work-Life Pressure", "High drive can create burnout or imbalance.");
    if (highestLeadershipStyle.includes('vis'))
      return renderItem("Long-View Buy-In", "Stakeholders may prefer short-term wins over long-term vision.");
  }
  const challengesPointFive = () => {
    if (highestLeadershipStyle.includes('col'))
      return renderItem("High Time + Energy Demand", "Collaboration requires more time and bandwidth.");
    if (highestLeadershipStyle.includes('strat'))
      return renderItem("Decision Bottlenecks", "Team may over-rely on the leader for direction.");
    if (highestLeadershipStyle.includes('per'))
      return renderItem("Hard on Failure", "High expectations can make setbacks harder to process.");
    if (highestLeadershipStyle.includes('vis'))
      return renderItem("Feeling Misunderstood", "Unconventional thinking can lead to isolation.");
  }
  return (
    <>
      <style>{`
        .ls-container{ padding:12px 0; display:flex; flex-direction:column; flex:1; gap:13px }
        .ls-title{ font-size:14px; line-height:18px; font-weight:700; font-family:Lato, sans-serif; color:#00577D; margin:0; text-align:left; letter-spacing:0 }
        .ls-paragraph{ font-size:12px; line-height:18px; font-weight:700; font-family:Lato, sans-serif; color:#00577D; margin:10px 0; }
        .ls-first{ display:flex; align-items:flex-start; margin-bottom:1px; gap:10px; }
        .ls-cover{ width:108px; height:108px; flex-shrink:0; object-fit:contain; }
        .ls-text{ flex:1; font-size:10px; line-height:14px; font-weight:400; padding-top: 10px; font-family:Lato, sans-serif; color:#000; margin:1px; letter-spacing:0; }
        .ls-text-paragraph{ flex:1; font-size:10px; line-height:14px; font-weight:400; font-family:Lato, sans-serif; color:#000000; margin:0; letter-spacing:0; }
        .ls-cardBlue, .ls-cardRed{ padding:10px; border-radius:5px; display:flex; gap:10px; flex-direction:column }
        .ls-cardBlue{ background-color:#F1F8F1; }
        .ls-cardRed { background-color:#FFF0EC; }
        .ls-subtitle{ font-size:10px; line-height:22px; font-weight:700; font-family:Lato, sans-serif; color:#000; margin:0; letter-spacing:0 }
        .list { margin:0; padding-left:17.5px }
        .ls-listItem{ font-size:10px; line-height:14px; font-weight:400; font-family:Lato, sans-serif; color:#000; letter-spacing:0 }
      `}</style>

      <div style={{ backgroundColor: "rgb(255, 255, 255)" }}>
        <HeaderPreview />
        <style>{styles.checkboxStyles}</style>
        <div style={styles.page}>
          <div style={styles.aboutSection} className="about-report-section">
            <h4 style={styles.title}>
              YOU REFLECT A {getLeadershipHeading()} LEADERSHIP STYLE (360)
            </h4>
            <div style={{ ...styles.iconRow, gap: highestLeadershipStyle.includes('col') ? '6px' : '16px' }}>
              <img src={getLeadershipImg()} alt="" style={styles.iconImage}></img>
              <div>
                <p style={styles.iconText}>
                  {getLeadershipInfo()}{" "}
                </p>
                <p style={styles.iconText2}>
                  {getLeadershipInfo2()}
                </p>
              </div>
            </div>
            <p style={styles.iconText}>
              {getLeadershipInfo3()}
            </p>
            <p style={styles.iconText}>
              {getLeadershipInfo4()}
            </p>

          </div>
          <div style={styles.card}>
            <h4 style={styles.cardTitle}>
              POSSIBLE CONTRIBUTIONS OF A {getLeadershipHeading()} LEADER
            </h4>
            <ul style={styles.list}>
              {pointOne()}
              {pointTwo()}
              {pointThree()}
              {pointFour()}
              {pointFive()}
            </ul>
          </div>
          <div style={styles.cardChallenges}>
            <h4 style={styles.cardTitle}>
              POSSIBLE CHALLENGES FOR A {getLeadershipHeading()} LEADER
            </h4>
            <ul style={styles.list}>
              {challengesPointOne()}
              {challengesPointTwo()}
              {challengesPointThree()}
              {challengesPointFour()}
              {challengesPointFive()}
            </ul>
          </div>
        </div>
        <FooterPreview pageNumber={pageNumber} reportType={reportType} />
      </div>
    </>
  );
};

export default LeadershipCollabrative;
